import { Navigate, Outlet } from 'react-router-dom';

export default function UnavailableRoute({ enabled }) {
  return enabled ? <Outlet /> : <Navigate to="/" />;
}
